import React from 'react';
import PropTypes from 'prop-types';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { AccountACHTransferAccountSummaryCard } from 'src/Components/Accounts/AccountACHTransferSummary';
import CollapsibleDisclaimer
  from 'Components/ComponentLibrary/Components/Uncategorized/CollapsibleDisclaimer';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import {
  Box, FDBodyText, Stack,
} from '@facet-wealth/design';
import AchTransferLayout from 'Views/Page/Content/Modal/Layouts/ACHTransfer/AchTransferLayout';
import ACHTransferTemplateOverride
  from './ACHTransferTemplateOverride';

const ACHTransferTemplateContent = ({
  errors,
  onChange,
}) => {
  const { pageContentResource: resource } = usePageContentContext();
  const [fromAccount] = resource.attr('from');
  const [toAccount] = resource.attr('to');

  const isWithdrawal = resource.id() === 'ACHTransferWithdrawalStep' || resource.id() === 'ACHTransferIRADistributionStep';

  return (
    <PageContentContainer>
      <PageContentTop
        badgeImage={resource.attr('badgeImage')}
        badgeImageAlt={resource.attr('badgeImageAlt')}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />

      <AccountACHTransferAccountSummaryCard isWithdrawal={isWithdrawal} fromAccount={fromAccount} toAccount={toAccount} />

      <Box width={'100%'} overflow={'hidden'}>
        <Stack direction={'column'} spacing={1} alignItems="flex-start" justifyContent="flex-start">
          <FDBodyText size={'md'} value={'Transfer Details'} />
          <MetaFormInline
            fullWidth
            padding={'none'}
            noIndividualSubmitButtons
            resource={resource}
            metaOverrideSet={ACHTransferTemplateOverride(resource)}
            errorsOverride={errors}
            layout={AchTransferLayout}
            LayoutProps={{
              ErrorListProps: {
                scrollIntoView: true,
              },
            }}
            onChange={(attr, value) => {
              return onChange(attr, value);
            }}
          />
        </Stack>
      </Box>

      <CollapsibleDisclaimer
        disclaimerText={resource.attr('disclaimerText')}
        disclaimerReadMore={resource.attr('disclaimerReadMoreText')}
      />
    </PageContentContainer>
  );
};

ACHTransferTemplateContent.defaultProps = {
  errors: undefined,
};

ACHTransferTemplateContent.propTypes = {
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default ACHTransferTemplateContent;
